<template>
    <div class="careers-career">
      <div class="careers-career-content">
          <p class="indent">Buone relazioni intra-societarie e un'efficace gestione delle risorse umane sono una parte essenziale della strategia aziendale di Alcomet. Gli obiettivi principali dell'azienda sono l'aumento della motivazione e della soddisfazione dei dipendenti e l'offerta di condizioni di lavoro eccellenti, garantendo un ambiente di lavoro sano e sicuro. L'azienda rispetta i diritti umani di ogni dipendente, riconosce le differenze individuali e offre pari opportunità di carriera e di sviluppo, indipendentemente da nazionalità, convinzioni, religione, etnia ed età. </p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.careers-career-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-career-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto 0;
  text-align: justify;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .careers-career-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Career.vue